/* Screen copy extracted from JSX and UI messages. Keep keys stable when adding another locale. */
export const uiMessages = {
  " · 共 {value0} 筆": " · 共 {value0} 筆",
  "，連續": "，連續",
  "、每": "、每",
  "（此頁）": "（此頁）",
  "（帳號資料）": "（帳號資料）",
  "（選填）": "（選填）",
  "[季租預約] 送出失敗": "[季租預約] 送出失敗",
  "[季租預約] POST /booking-series": "[季租預約] POST /booking-series",
  "[預約場地] 訂單確認失敗": "[預約場地] 訂單確認失敗",
  "[預約場地] 送出失敗": "[預約場地] 送出失敗",
  "[預約場地] 營業時間檢查": "[預約場地] 營業時間檢查",
  "[預約場地] POST /bookings": "[預約場地] POST /bookings",
  "{count} 則未讀{scope}": "{count} 則未讀{scope}",
  "{value0} · {value1} 場活動": "{value0} · {value1} 場活動",
  "{value0} ({value1}/{value2}人)": "{value0} ({value1}/{value2}人)",
  "{value0} {value1} {value2} 至 {value3}，{value4}": "{value0} {value1} {value2} 至 {value3}，{value4}",
  "{value0} {value1} 至 {value2}，{value3}": "{value0} {value1} 至 {value2}，{value3}",
  "{value0} 人": "{value0} 人",
  "{value0} 至 {value1}": "{value0} 至 {value1}",
  "{value0} 的頭像": "{value0} 的頭像",
  "{value0}・{value1} / 小時": "{value0}・{value1} / 小時",
  "{value0}・{value1} 至 {value2}": "{value0}・{value1} 至 {value2}",
  "{value0}・{value1} 個場地": "{value0}・{value1} 個場地",
  "{value0}{value1} {value2} 至 {value3}，{value4}": "{value0}{value1} {value2} 至 {value3}，{value4}",
  "{value0}場地照片": "{value0}場地照片",
  "「{value0}・{value1}」{value2} 不在可預約時間內（營業時間 {value3}–{value4}）。請返回重新選擇。": "「{value0}・{value1}」{value2} 不在可預約時間內（營業時間 {value3}–{value4}）。請返回重新選擇。",
  "」的場地資料": "」的場地資料",
  "」這筆預約嗎？": "」這筆預約嗎？",
  "/ 小時": "/ 小時",
  "12 個月": "12 個月",
  "20人": "20人",
  "3 個月": "3 個月",
  "6 個月": "6 個月",
  "人": "人",
  "人・點擊查看詳情": "人・點擊查看詳情",
  "人（含本人）": "人（含本人）",
  "人數上限必須為正整數。": "人數上限必須為正整數。",
  "入口": "入口",
  "上一頁": "上一頁",
  "上一週": "上一週",
  "上次預約": "上次預約",
  "上傳計畫書(.pdf)": "上傳計畫書(.pdf)",
  "下一頁": "下一頁",
  "下一週": "下一週",
  "大草地": "大草地",
  "女性": "女性",
  "小時": "小時",
  "已付款": "已付款",
  "已成功送出": "已成功送出",
  "已有 {value0} 筆預約成功送出，其餘尚未完成。{value1} 再次送出時會略過已成功的項目。": "已有 {value0} 筆預約成功送出，其餘尚未完成。{value1} 再次送出時會略過已成功的項目。",
  "已有帳號？": "已有帳號？",
  "已有部分單次預約送出，請先完成剩餘預約。": "已有部分單次預約送出，請先完成剩餘預約。",
  "已取消": "已取消",
  "已送出 {value0} 人的團體報名，請等待主揪確認。": "已送出 {value0} 人的團體報名，請等待主揪確認。",
  "已送出 {value0} 個月的固定時段預約，請等候審核並依場地方通知於現場付款。": "已送出 {value0} 個月的固定時段預約，請等候審核並依場地方通知於現場付款。",
  "已送出 {value0} 筆預約，請耐心等候審核，並依場地方通知於現場付款。": "已送出 {value0} 筆預約，請耐心等候審核，並依場地方通知於現場付款。",
  "已被預約": "已被預約",
  "已報名": "已報名",
  "已結束": "已結束",
  "已經報名": "已經報名",
  "已過時段": "已過時段",
  "已預約": "已預約",
  "已滿": "已滿",
  "已確認": "已確認",
  "已確認 LINE 身分。再填寫以下資料即可建立帳號。": "已確認 LINE 身分。再填寫以下資料即可建立帳號。",
  "已閱讀": "已閱讀",
  "已選": "已選",
  "已選擇": "已選擇",
  "已讀": "已讀",
  "不限程度": "不限程度",
  "不設上限": "不設上限",
  "公告": "公告",
  "切換為": "切換為",
  "方便玩家加好友聯絡": "方便玩家加好友聯絡",
  "日期": "日期",
  "日期：": "日期：",
  "主揪": "主揪",
  "主揪取消報名": "主揪取消報名",
  "主揪尚未提供聯絡方式": "主揪尚未提供聯絡方式",
  "主揪尚未提供額外備註。": "主揪尚未提供額外備註。",
  "主揪備註": "主揪備註",
  "主揪資訊": "主揪資訊",
  "主辦人": "主辦人",
  "主辦人須知": "主辦人須知",
  "主辦人資料": "主辦人資料",
  "主辦人需負責處理該團之場地費用與退款事宜。": "主辦人需負責處理該團之場地費用與退款事宜。",
  "付款方式：現場付款": "付款方式：現場付款",
  "付款失敗": "付款失敗",
  "付款狀態：": "付款狀態：",
  "付款狀態：{status}": "付款狀態：{status}",
  "付款狀態更新": "付款狀態更新",
  "以 LINE 建立帳號": "以 LINE 建立帳號",
  "以下日期與既有預約衝突，整筆長期預約未建立。請返回調整日期、場面或時段。": "以下日期與既有預約衝突，整筆長期預約未建立。請返回調整日期、場面或時段。",
  "以下為活動目前的資訊。": "以下為活動目前的資訊。",
  "出生日期": "出生日期",
  "出生日期錯誤": "出生日期錯誤",
  "半年租": "半年租",
  "卡片": "卡片",
  "只看可選時段": "只看可選時段",
  "只預約上方時段": "只預約上方時段",
  "可同時選擇不同場面與時段；再次點擊已選時段可取消。": "可同時選擇不同場面與時段；再次點擊已選時段可取消。",
  "可預約場面": "可預約場面",
  "可複選不同場面、日期及不連續時段": "可複選不同場面、日期及不連續時段",
  "可選擇": "可選擇",
  "打球租與揪系統": "打球租與揪系統",
  "未命名組織": "未命名組織",
  "未定日期": "未定日期",
  "未定時間": "未定時間",
  "未指定": "未指定",
  "未設定": "未設定",
  "未設定 username": "未設定 username",
  "未通過": "未通過",
  "未提供": "未提供",
  "未提供 username": "未提供 username",
  "未提供主揪資訊": "未提供主揪資訊",
  "未提供地點": "未提供地點",
  "未開放": "未開放",
  "未經體育室核准，不得於借用場地進行商業(收費)教學或訓練之行為。": "未經體育室核准，不得於借用場地進行商業(收費)教學或訓練之行為。",
  "未確認": "未確認",
  "未讀": "未讀",
  "未讀數回應格式不正確": "未讀數回應格式不正確",
  "本人": "本人",
  "本人的運動程度由帳號設定帶入。": "本人的運動程度由帳號設定帶入。",
  "正在取得目前位置...": "正在取得目前位置...",
  "正在透過 LINE 驗證身分…": "正在透過 LINE 驗證身分…",
  "正在載入帳號資料…": "正在載入帳號資料…",
  "正在載入通知…": "正在載入通知…",
  "正在載入運動程度…": "正在載入運動程度…",
  "正在確認場地可預約時段…": "正在確認場地可預約時段…",
  "正式串接後，此步會由後端建立或查找帳號、簽發系統登入憑證，並帶你進入臨打頁。": "正式串接後，此步會由後端建立或查找帳號、簽發系統登入憑證，並帶你進入臨打頁。",
  "申請人（含電話）": "申請人（含電話）",
  "申請已送出！管理員將在 1-3 個工作天內審核。": "申請已送出！管理員將在 1-3 個工作天內審核。",
  "申請成為臨打團長": "申請成為臨打團長",
  "申請取消中": "申請取消中",
  "申請借用及使用場地時，請出示教職員工證或學生證（有效學籍之學生證）。": "申請借用及使用場地時，請出示教職員工證或學生證（有效學籍之學生證）。",
  "申請借用場地時，請依本校運動場地管理辦法提出申請；場地借用申請表須先經總務所、管理單位審章同意，並請檢附參加人員名單及活動企劃。": "申請借用場地時，請依本校運動場地管理辦法提出申請；場地借用申請表須先經總務所、管理單位審章同意，並請檢附參加人員名單及活動企劃。",
  "申請單位": "申請單位",
  "目前沒有可選的程度。": "目前沒有可選的程度。",
  "目前沒有可選的運動程度。": "目前沒有可選的運動程度。",
  "目前沒有可選擇的開放場地。": "目前沒有可選擇的開放場地。",
  "目前沒有可顯示的營業時段。": "目前沒有可顯示的營業時段。",
  "目前沒有未讀通知。": "目前沒有未讀通知。",
  "目前沒有通知。": "目前沒有通知。",
  "目前沒有場地資料。": "目前沒有場地資料。",
  "目前沒有提供": "目前沒有提供",
  "目前沒有進行中或即將開始的預約": "目前沒有進行中或即將開始的預約",
  "目前沒有歷史預約": "目前沒有歷史預約",
  "目前的帳號沒有執行此操作的權限。": "目前的帳號沒有執行此操作的權限。",
  "目前的帳號沒有報名權限。": "目前的帳號沒有報名權限。",
  "目前球類尚未設定程度，暫時無法開團。": "目前球類尚未設定程度，暫時無法開團。",
  "目前無法使用 LINE 登入，請稍後再試。": "目前無法使用 LINE 登入，請稍後再試。",
  "目前僅提供此程度": "目前僅提供此程度",
  "立即預約": "立即預約",
  "先不要": "先不要",
  "全部": "全部",
  "全部通知已標記為已讀。": "全部通知已標記為已讀。",
  "全部標為已讀": "全部標為已讀",
  "共": "共",
  "共 {count} 則": "共 {count} 則",
  "再次體驗 LINE 登入": "再次體驗 LINE 登入",
  "同一筆長期預約須使用固定時段，請返回調整選取項目。": "同一筆長期預約須使用固定時段，請返回調整選取項目。",
  "回到目前位置": "回到目前位置",
  "回到登入": "回到登入",
  "已取消 LINE 登入，請重新嘗試。": "已取消 LINE 登入，請重新嘗試。",
  "LINE 登入尚未在伺服器設定完成。": "LINE 登入尚未在伺服器設定完成。",
  "LINE 授權驗證失敗。請重新從登入頁開始；若持續發生，請檢查後端 LINE Channel 設定。": "LINE 授權驗證失敗。請重新從登入頁開始；若持續發生，請檢查後端 LINE Channel 設定。",
  "請在外部瀏覽器完成 LINE 登入": "請在外部瀏覽器完成 LINE 登入",
  "開啟 LINE 登入": "開啟 LINE 登入",
  "在 Google Maps 開啟位置": "在 Google Maps 開啟位置",
  "在 Google Maps 開啟停車場導航": "在 Google Maps 開啟停車場導航",
  "在地圖中查看": "在地圖中查看",
  "地點": "地點",
  "地點：": "地點：",
  "地點暫時無法載入": "地點暫時無法載入",
  "多場地單日": "多場地單日",
  "如有特殊原因需取消使用時，本室有權利隨時通知申請人停止或改期借用，不得異議。": "如有特殊原因需取消使用時，本室有權利隨時通知申請人停止或改期借用，不得異議。",
  "安全碼": "安全碼",
  "年齡": "年齡",
  "成員資料": "成員資料",
  "收合資訊": "收合資訊",
  "有可選時段": "有可選時段",
  "此分頁已有展示帳號「{value0}」，可以體驗再次登入。": "此分頁已有展示帳號「{value0}」，可以體驗再次登入。",
  "此使用者名稱或 LINE 帳號已被使用。": "此使用者名稱或 LINE 帳號已被使用。",
  "此金額僅供參考，實際付款方式依主揪安排。": "此金額僅供參考，實際付款方式依主揪安排。",
  "此頁沒有符合所選日期的臨打團，請切換頁面查看。": "此頁沒有符合所選日期的臨打團，請切換頁面查看。",
  "此時間段已有報名活動。": "此時間段已有報名活動。",
  "此停車場尚未提供座標": "此停車場尚未提供座標",
  "此球類尚未設定程度": "此球類尚未設定程度",
  "此通知沒有附加內容。": "此通知沒有附加內容。",
  "此場地目前沒有可預約的場面。": "此場地目前沒有可預約的場面。",
  "此場地目前暫停開放。": "此場地目前暫停開放。",
  "此場地尚未提供座標": "此場地尚未提供座標",
  "此場地尚未提供詳細介紹。": "此場地尚未提供詳細介紹。",
  "此場地暫停開放。": "此場地暫停開放。",
  "羽球": "羽球",
  "羽球場": "羽球場",
  "自": "自",
  "自 {date} 起，每{days} {time}，連續 {months} 個月。": "自 {date} 起，每{days} {time}，連續 {months} 個月。",
  "自習室": "自習室",
  "至": "至",
  "位 ·": "位 ·",
  "位成員資料尚未提供。": "位成員資料尚未提供。",
  "位置": "位置",
  "位置未提供": "位置未提供",
  "你已報名這個臨打團，請到我的預約查看。": "你已報名這個臨打團，請到我的預約查看。",
  "你已選擇：{value0} - {value1}": "你已選擇：{value0} - {value1}",
  "你目前參與的運動社群": "你目前參與的運動社群",
  "你的運動程度已儲存。": "你的運動程度已儲存。",
  "你確定要取消「": "你確定要取消「",
  "你還沒有設定這個球類的程度。": "你還沒有設定這個球類的程度。",
  "你還沒有設定這個球類的程度。請選擇符合自己的程度後儲存。": "你還沒有設定這個球類的程度。請選擇符合自己的程度後儲存。",
  "冷氣": "冷氣",
  "即將開始 · 24 小時內": "即將開始 · 24 小時內",
  "即將開始的已報名活動": "即將開始的已報名活動",
  "完成展示註冊": "完成展示註冊",
  "完成帳號設定": "完成帳號設定",
  "完成預約": "完成預約",
  "快開始": "快開始",
  "我已詳細閱讀，並同意遵守主辦人規範。": "我已詳細閱讀，並同意遵守主辦人規範。",
  "我已預約": "我已預約",
  "我的通知": "我的通知",
  "我的程度": "我的程度",
  "我的預約": "我的預約",
  "找不到": "找不到",
  "找不到 resource_id（請重新選擇場地/球場後再試一次）": "找不到 resource_id（請重新選擇場地/球場後再試一次）",
  "找不到「": "找不到「",
  "找不到相關資料，請重新整理後再試。": "找不到相關資料，請重新整理後再試。",
  "找不到這個臨打團，請重新整理列表。": "找不到這個臨打團，請重新整理列表。",
  "改用帳號密碼登入": "改用帳號密碼登入",
  "更衣室": "更衣室",
  "更新個人資料失敗：": "更新個人資料失敗：",
  "更新程度失敗：": "更新程度失敗：",
  "每頁顯示": "每頁顯示",
  "每筆長期預約固定同一面場地與同一時段；如有任一日期衝突，整筆都不會建立。": "每筆長期預約固定同一面場地與同一時段；如有任一日期衝突，整筆都不會建立。",
  "汽車停車場": "汽車停車場",
  "沒有這東西": "沒有這東西",
  "沒有權限": "沒有權限",
  "男性": "男性",
  "系統通知": "系統通知",
  "系統暫時無法處理": "系統暫時無法處理",
  "足球": "足球",
  "足球場": "足球場",
  "使用 LINE 登入／註冊": "使用 LINE 登入／註冊",
  "使用者": "使用者",
  "使用者名稱": "使用者名稱",
  "使用者頭像": "使用者頭像",
  "使用規則": "使用規則",
  "使用與登記內容不符或有違本校運動場地管理辦法時，體育室得立即禁止使用者行為。": "使用與登記內容不符或有違本校運動場地管理辦法時，體育室得立即禁止使用者行為。",
  "例如 LINE ID 或聯絡方式；請填寫願意提供給參加者的資訊": "例如 LINE ID 或聯絡方式；請填寫願意提供給參加者的資訊",
  "例如：因為想找別人切磋球技，常在台大體育館打球": "例如：因為想找別人切磋球技，常在台大體育館打球",
  "其他": "其他",
  "其餘": "其餘",
  "取消": "取消",
  "取消申請": "取消申請",
  "取消申請中": "取消申請中",
  "取消申請失敗：": "取消申請失敗：",
  "取消並返回": "取消並返回",
  "取消預約": "取消預約",
  "取得已預約時段失敗：": "取得已預約時段失敗：",
  "取得訂單資料中...": "取得訂單資料中...",
  "取得訂單資料失敗：": "取得訂單資料失敗：",
  "取得個人資料失敗：": "取得個人資料失敗：",
  "取得場地資訊中...": "取得場地資訊中...",
  "季租": "季租",
  "季租、半年租及年租只能選同一面場地，請返回調整選取項目。": "季租、半年租及年租只能選同一面場地，請返回調整選取項目。",
  "尚未取得帳號名稱": "尚未取得帳號名稱",
  "尚未設定": "尚未設定",
  "尚未提供": "尚未提供",
  "尚未提供位置資訊": "尚未提供位置資訊",
  "尚未提供使用規則。": "尚未提供使用規則。",
  "尚未提供停車資訊": "尚未提供停車資訊",
  "尚未提供設施資訊": "尚未提供設施資訊",
  "尚未提供設施資訊。": "尚未提供設施資訊。",
  "尚未選擇球類": "尚未選擇球類",
  "尚未選擇球類，請先選擇球類再設定程度。": "尚未選擇球類，請先選擇球類再設定程度。",
  "性別": "性別",
  "性別：": "性別：",
  "性別：{gender}": "性別：{gender}",
  "或": "或",
  "所選長期時段與既有預約衝突，整筆長期預約未建立。請返回調整後再試。": "所選長期時段與既有預約衝突，整筆長期預約未建立。請返回調整後再試。",
  "所選時段不在場地可預約時間內，請返回重新選擇。": "所選時段不在場地可預約時間內，請返回重新選擇。",
  "所選時段參考金額": "所選時段參考金額",
  "所屬組織": "所屬組織",
  "近期已報名活動載入失敗：": "近期已報名活動載入失敗：",
  "返回修改預約": "返回修改預約",
  "返回場地列表": "返回場地列表",
  "返回登入頁": "返回登入頁",
  "返回預約頁": "返回預約頁",
  "長期租用時段必須是有效的 30 分鐘間隔，請返回重新選擇。": "長期租用時段必須是有效的 30 分鐘間隔，請返回重新選擇。",
  "長期預約已送出": "長期預約已送出",
  "長期預約的起始日期與時段須在未來，請返回重新選擇。": "長期預約的起始日期與時段須在未來，請返回重新選擇。",
  "附近停車位置": "附近停車位置",
  "雨天或場地維修時，場地可能會臨時關閉": "雨天或場地維修時，場地可能會臨時關閉",
  "非營業時間": "非營業時間",
  "信用卡號": "信用卡號",
  "則": "則",
  "則未讀": "則未讀",
  "前往我的預約": "前往我的預約",
  "前往確認": "前往確認",
  "前往臨打頁面": "前往臨打頁面",
  "建立中…": "建立中…",
  "建立成功": "建立成功",
  "建立帳號": "建立帳號",
  "建立帳號中…": "建立帳號中…",
  "建立臨打團": "建立臨打團",
  "待付款": "待付款",
  "待審核": "待審核",
  "待確認": "待確認",
  "急救設施": "急救設施",
  "按下方按鈕，模擬完成 LINE 授權後補填註冊資料。": "按下方按鈕，模擬完成 LINE 授權後補填註冊資料。",
  "查看{value0}的 {value1} 場活動": "查看{value0}的 {value1} 場活動",
  "查看{value0}臨打團詳細資訊": "查看{value0}臨打團詳細資訊",
  "查看位置": "查看位置",
  "查看活動資訊": "查看活動資訊",
  "查看相關資訊": "查看相關資訊",
  "查看停車位置": "查看停車位置",
  "查看場地詳情 →": "查看場地詳情 →",
  "活動人數": "活動人數",
  "活動不存在": "活動不存在",
  "活動地點": "活動地點",
  "活動更新": "活動更新",
  "活動取消": "活動取消",
  "活動時間": "活動時間",
  "活動報名已截止": "活動報名已截止",
  "活動開始前 24 小時內將無法取消報名。": "活動開始前 24 小時內將無法取消報名。",
  "活動說明、場地面數或注意事項": "活動說明、場地面數或注意事項",
  "為什麼想成為主辦人？常在哪裡打球？": "為什麼想成為主辦人？常在哪裡打球？",
  "相關報名編號": "相關報名編號",
  "相關臨打團": "相關臨打團",
  "相關臨打團已不存在或無法查看。": "相關臨打團已不存在或無法查看。",
  "若收到多次惡意放鳥投訴，平台將收回權限。": "若收到多次惡意放鳥投訴，平台將收回權限。",
  "訂單已送出！請耐心等候審核。": "訂單已送出！請耐心等候審核。",
  "訂單金額無法確認，請返回重新選擇。": "訂單金額無法確認，請返回重新選擇。",
  "訂單資料不完整，請返回重新選擇場地與時段。": "訂單資料不完整，請返回重新選擇場地與時段。",
  "負責人": "負責人",
  "負責人（領隊）": "負責人（領隊）",
  "重新載入": "重新載入",
  "重新載入相關資訊": "重新載入相關資訊",
  "重新載入程度": "重新載入程度",
  "重新載入程度選項": "重新載入程度選項",
  "重新整理": "重新整理",
  "重新體驗首次註冊": "重新體驗首次註冊",
  "重試": "重試",
  "重試剩餘預約": "重試剩餘預約",
  "面": "面",
  "面場地": "面場地",
  "頁": "頁",
  "個人報名": "個人報名",
  "個人程度回應格式不正確": "個人程度回應格式不正確",
  "個人資料": "個人資料",
  "個人資料已更新。": "個人資料已更新。",
  "個人資料與程度已更新。": "個人資料與程度已更新。",
  "個人與聯絡資料": "個人與聯絡資料",
  "個人檔案": "個人檔案",
  "個月。": "個月。",
  "個名額。團體報名會一次占用全部所選名額。": "個名額。團體報名會一次占用全部所選名額。",
  "個時段・": "個時段・",
  "個場地": "個場地",
  "借用單位應自行負責使用者之活動安全，並符合主管機關安全法規。": "借用單位應自行負責使用者之活動安全，並符合主管機關安全法規。",
  "借用場地時，除應維持清潔外，活動後負責將垃圾帶離現場。": "借用場地時，除應維持清潔外，活動後負責將垃圾帶離現場。",
  "借用須知": "借用須知",
  "容納人數": "容納人數",
  "展示模式不會建立真實帳號或登入系統。": "展示模式不會建立真實帳號或登入系統。",
  "時段": "時段",
  "時段格式無法解析（請返回修改預約）": "時段格式無法解析（請返回修改預約）",
  "時間": "時間",
  "時間：": "時間：",
  "時間未提供": "時間未提供",
  "校內借用使用時間：單次借用以三天(含六、日)。": "校內借用使用時間：單次借用以三天(含六、日)。",
  "校內單位借用，如在歸還時間內，未按時恢復原狀，停止日後借用之權利申請不得異議。": "校內單位借用，如在歸還時間內，未按時恢復原狀，停止日後借用之權利申請不得異議。",
  "真實姓名": "真實姓名",
  "租借事由": "租借事由",
  "租借時間": "租借時間",
  "租借需求": "租借需求",
  "缺少 REACT_APP_LIFF_ID 設定": "缺少 REACT_APP_LIFF_ID 設定",
  "起，每": "起，每",
  "送出{period}": "送出{period}",
  "送出{value0}": "送出{value0}",
  "送出中...": "送出中...",
  "送出中…": "送出中…",
  "送出成功": "送出成功",
  "送出的資料有誤，請檢查後再試。": "送出的資料有誤，請檢查後再試。",
  "送出後會一次建立整段租期的預約並等待審核，此頁不會線上扣款。上方僅為本次所選時段的參考金額，長期租期的實際總額請依場地方通知於現場支付。": "送出後會一次建立整段租期的預約並等待審核，此頁不會線上扣款。上方僅為本次所選時段的參考金額，長期租期的實際總額請依場地方通知於現場支付。",
  "送出後會建立預約並等待審核，此頁不會線上扣款。請依場地方通知，在現場支付上方金額。": "送出後會建立預約並等待審核，此頁不會線上扣款。請依場地方通知，在現場支付上方金額。",
  "送出預約": "送出預約",
  "送出審核中...": "送出審核中...",
  "停車場": "停車場",
  "停車資訊": "停車資訊",
  "基本資料": "基本資料",
  "基本資料已更新，但程度未更新。{value0}": "基本資料已更新，但程度未更新。{value0}",
  "基本資訊": "基本資訊",
  "基於活動安全之考量，借用者如改用瓦斯或明火烹煮，將暫停借用場地，並不得要求賠償。": "基於活動安全之考量，借用者如改用瓦斯或明火烹煮，將暫停借用場地，並不得要求賠償。",
  "帳號資料缺少 username": "帳號資料缺少 username",
  "排序方式": "排序方式",
  "排球": "排球",
  "排球場": "排球場",
  "教室": "教室",
  "淋浴間": "淋浴間",
  "清除": "清除",
  "清除選取": "清除選取",
  "現場應付金額": "現場應付金額",
  "球場": "球場",
  "球類": "球類",
  "球類：": "球類：",
  "第": "第",
  "第 {page}{total} 頁": "第 {page}{total} 頁",
  "第 {value0} 位：同行者": "第 {value0} 位：同行者",
  "第 {value0} 面": "第 {value0} 面",
  "第 {value0} 面場地 / {value1}-{value2}": "第 {value0} 面場地 / {value1}-{value2}",
  "第 1 位：本人": "第 1 位：本人",
  "處理中...": "處理中...",
  "處理中…": "處理中…",
  "設定": "設定",
  "設定成功": "設定成功",
  "設定你的運動程度": "設定你的運動程度",
  "設定程度": "設定程度",
  "設施": "設施",
  "這個日期目前沒有符合條件的場地，試試其他日期。": "這個日期目前沒有符合條件的場地，試試其他日期。",
  "這個球類目前沒有可選的程度。": "這個球類目前沒有可選的程度。",
  "這個臨打團已超過報名截止時間，無法再報名。": "這個臨打團已超過報名截止時間，無法再報名。",
  "這筆訂單尚未提供成員資料。": "這筆訂單尚未提供成員資料。",
  "這裡有": "這裡有",
  "通知": "通知",
  "通知，{count} 則未讀": "通知，{count} 則未讀",
  "通知，有未讀通知": "通知，有未讀通知",
  "通知已標記為已讀。": "通知已標記為已讀。",
  "通知分頁": "通知分頁",
  "通知列表回應格式不正確": "通知列表回應格式不正確",
  "通知篩選": "通知篩選",
  "連線逾時": "連線逾時",
  "連線逾時，請確認網路環境後重試。": "連線逾時，請確認網路環境後重試。",
  "部分已選時段目前無法預約，請取消該時段或清除選取後重新選擇。": "部分已選時段目前無法預約，請取消該時段或清除選取後重新選擇。",
  "部分未確認": "部分未確認",
  "部分場地時段無法確認：": "部分場地時段無法確認：",
  "最低": "最低",
  "最高": "最高",
  "剩餘": "剩餘",
  "單日多場地": "單日多場地",
  "單次預約": "單次預約",
  "單場地七日": "單場地七日",
  "報名人數：": "報名人數：",
  "報名人數（含本人）": "報名人數（含本人）",
  "報名已截止": "報名已截止",
  "報名方式": "報名方式",
  "報名未通過": "報名未通過",
  "報名取消": "報名取消",
  "報名狀態：": "報名狀態：",
  "報名狀態：{status}": "報名狀態：{status}",
  "報名者帳號名稱": "報名者帳號名稱",
  "報名時間衝突": "報名時間衝突",
  "報名通知": "報名通知",
  "報名截止": "報名截止",
  "報名截止日期": "報名截止日期",
  "報名截止時間不能晚於開始時間。": "報名截止時間不能晚於開始時間。",
  "報名截止時間必須晚於現在。": "報名截止時間必須晚於現在。",
  "報名確認": "報名確認",
  "場地": "場地",
  "場地：{value0} / 第 {value1} 面": "場地：{value0} / 第 {value1} 面",
  "場地位置": "場地位置",
  "場地狀態": "場地狀態",
  "場地借用申請時，校內請於使用日期10-14天前；校外借用30-45天前。(但經簽請本校核准之活動或競賽不在此限。)": "場地借用申請時，校內請於使用日期10-14天前；校外借用30-45天前。(但經簽請本校核准之活動或競賽不在此限。)",
  "場地時段金額總覽": "場地時段金額總覽",
  "場地清單格式不正確": "場地清單格式不正確",
  "場地設施": "場地設施",
  "場地搜尋結果": "場地搜尋結果",
  "場地資料": "場地資料",
  "場地資料載入失敗：": "場地資料載入失敗：",
  "場地資訊": "場地資訊",
  "場地資訊載入失敗，請重新整理頁面。": "場地資訊載入失敗，請重新整理頁面。",
  "場地預約": "場地預約",
  "場地圖片": "場地圖片",
  "場地與可預約時段": "場地與可預約時段",
  "場地檢視方式": "場地檢視方式",
  "場活動": "場活動",
  "場面的場館。": "場面的場館。",
  "廁所": "廁所",
  "提醒：你報名的臨打團將在兩天內開始": "提醒：你報名的臨打團將在兩天內開始",
  "期限": "期限",
  "棒球": "棒球",
  "無法取得 LINE 身分驗證資訊，請重新開啟此頁面。": "無法取得 LINE 身分驗證資訊，請重新開啟此頁面。",
  "無法取得報名者帳號資料，請重新載入。": "無法取得報名者帳號資料，請重新載入。",
  "無法連線，請確認網路環境後重試。": "無法連線，請確認網路環境後重試。",
  "無法報名": "無法報名",
  "無法載入地圖，請稍後再試。": "無法載入地圖，請稍後再試。",
  "無法載入程度，請重試。": "無法載入程度，請重試。",
  "無法確認「{value0}」的場地資料，請稍後再試。": "無法確認「{value0}」的場地資料，請稍後再試。",
  "無法確認我的預約時段：": "無法確認我的預約時段：",
  "無法辨識選取的球類": "無法辨識選取的球類",
  "無障礙設施": "無障礙設施",
  "登入": "登入",
  "登入已失效": "登入已失效",
  "登入中...": "登入中...",
  "登入流程展示完成": "登入流程展示完成",
  "登入資訊": "登入資訊",
  "登出": "登出",
  "程度：": "程度：",
  "程度（目前球類）": "程度（目前球類）",
  "程度上限": "程度上限",
  "程度上限不能小於下限。": "程度上限不能小於下限。",
  "程度下限": "程度下限",
  "程度已更新。": "程度已更新。",
  "程度表分頁未正確更新": "程度表分頁未正確更新",
  "程度表回應格式不正確": "程度表回應格式不正確",
  "程度表資料格式不正確": "程度表資料格式不正確",
  "程度評分": "程度評分",
  "程度與費用": "程度與費用",
  "程度選擇錯誤": "程度選擇錯誤",
  "稍後再設定": "稍後再設定",
  "筆": "筆",
  "筆）": "筆）",
  "筆預約": "筆預約",
  "筆預約。": "筆預約。",
  "等級 {level}": "等級 {level}",
  "等級 {value0}": "等級 {value0}",
  "結束": "結束",
  "結束時間": "結束時間",
  "結束時間必須晚於開始時間。": "結束時間必須晚於開始時間。",
  "註冊失敗": "註冊失敗",
  "註冊流程展示完成": "註冊流程展示完成",
  "註冊帳號": "註冊帳號",
  "費用": "費用",
  "費用必須為 0 或正數。": "費用必須為 0 或正數。",
  "距離近": "距離近",
  "距離活動開始不到 24 小時，已無法取消報名。": "距離活動開始不到 24 小時，已無法取消報名。",
  "距離約 {distance} 公里": "距離約 {distance} 公里",
  "距離約 {value0} 公里": "距離約 {value0} 公里",
  "週一": "週一",
  "週二": "週二",
  "週三": "週三",
  "週五": "週五",
  "週六": "週六",
  "週日": "週日",
  "週四": "週四",
  "進行中": "進行中",
  "開始": "開始",
  "開始時間": "開始時間",
  "開放": "開放",
  "開放時間": "開放時間",
  "開放預約": "開放預約",
  "開發展示模式 · 不會連接 LINE 或建立真實帳號": "開發展示模式 · 不會連接 LINE 或建立真實帳號",
  "開團計畫": "開團計畫",
  "飲水機": "飲水機",
  "僅限英文字母與數字。": "僅限英文字母與數字。",
  "匯入 PDF 失敗:": "匯入 PDF 失敗:",
  "新增": "新增",
  "照明設備": "照明設備",
  "禁止在場地內飲食，只允許飲用水": "禁止在場地內飲食，只允許飲用水",
  "該使用者名稱已被使用": "該使用者名稱已被使用",
  "資料已變更或與其他操作衝突，請重新整理後再試。": "資料已變更或與其他操作衝突，請重新整理後再試。",
  "資料不存在": "資料不存在",
  "資料不完整": "資料不完整",
  "資料尚未完成": "資料尚未完成",
  "資料格式錯誤": "資料格式錯誤",
  "資料填寫": "資料填寫",
  "資料衝突": "資料衝突",
  "跟你們介紹一下這個網球場，這裡是拿來打籃球的，\n                            不是打羽球的": "跟你們介紹一下這個網球場，這裡是拿來打籃球的，\n                            不是打羽球的",
  "載入已預約時段中...": "載入已預約時段中...",
  "載入中": "載入中",
  "載入中…": "載入中…",
  "載入相關資訊中…": "載入相關資訊中…",
  "載入球類資料中...": "載入球類資料中...",
  "載入場地資料中...": "載入場地資料中...",
  "載入場地資料完成": "載入場地資料完成",
  "載入場地與程度資料中…": "載入場地與程度資料中…",
  "載入程度中…": "載入程度中…",
  "運動程度": "運動程度",
  "電子信箱": "電子信箱",
  "電子郵件": "電子郵件",
  "電話": "電話",
  "電話格式錯誤": "電話格式錯誤",
  "電話號碼未通過驗證，請確認格式後再試。": "電話號碼未通過驗證，請確認格式後再試。",
  "預約已送出": "預約已送出",
  "預約方式與租期": "預約方式與租期",
  "預約日期 :": "預約日期 :",
  "預約日期格式不正確，請返回重新選擇。": "預約日期格式不正確，請返回重新選擇。",
  "預約後請準時到場，遲到超過15分鐘視為棄權": "預約後請準時到場，遲到超過15分鐘視為棄權",
  "預約時段": "預約時段",
  "預約時間：": "預約時間：",
  "預約項目（": "預約項目（",
  "預約額滿": "預約額滿",
  "預計費用：NT$": "預計費用：NT$",
  "團員 {value0}": "團員 {value0}",
  "團體報名": "團體報名",
  "團體報名 ·": "團體報名 ·",
  "團體報名 · {value0} 人": "團體報名 · {value0} 人",
  "團體報名資訊": "團體報名資訊",
  "團體報名需至少 2 人，且不能超過剩餘的 {value0} 個名額。": "團體報名需至少 2 人，且不能超過剩餘的 {value0} 個名額。",
  "管理": "管理",
  "管理員": "管理員",
  "網球": "網球",
  "網球場": "網球場",
  "網路": "網路",
  "網路連線失敗": "網路連線失敗",
  "銀行代碼": "銀行代碼",
  "需提前 7 天": "需提前 7 天",
  "需提前 7 天預約，最早可選": "需提前 7 天預約，最早可選",
  "需提前 7 天預約，最早可選 {value0}。請返回重新選擇日期。": "需提前 7 天預約，最早可選 {value0}。請返回重新選擇日期。",
  "價格未提供": "價格未提供",
  "暫時無法讀取": "暫時無法讀取",
  "暫停開放": "暫停開放",
  "暫無空位": "暫無空位",
  "標記已讀": "標記已讀",
  "模擬 LINE 授權，開始註冊": "模擬 LINE 授權，開始註冊",
  "模擬 LINE 授權已完成，填寫必要資料即可預覽註冊結果。": "模擬 LINE 授權已完成，填寫必要資料即可預覽註冊結果。",
  "模擬 LINE 登入": "模擬 LINE 登入",
  "確認中": "確認中",
  "確認此時段": "確認此時段",
  "確認取消": "確認取消",
  "確認取消預約？": "確認取消預約？",
  "確認送出申請": "確認送出申請",
  "確認報名": "確認報名",
  "確認場地": "確認場地",
  "確認預約": "確認預約",
  "確認選擇": "確認選擇",
  "編輯資料": "編輯資料",
  "請先登入，才能確認自己的預約時段。": "請先登入，才能確認自己的預約時段。",
  "請先載入並選擇有效的程度。": "請先載入並選擇有效的程度。",
  "請先選擇有效的程度。": "請先選擇有效的程度。",
  "請先選擇球類": "請先選擇球類",
  "請先選擇場地": "請先選擇場地",
  "請先選擇場地與時段。": "請先選擇場地與時段。",
  "請注意維護場內各種設備，倘有毀損情事，應負賠償責任。": "請注意維護場內各種設備，倘有毀損情事，應負賠償責任。",
  "請保持場地清潔，離開時帶走所有個人物品和垃圾": "請保持場地清潔，離開時帶走所有個人物品和垃圾",
  "請持續關注通知並了解是否有名額釋出，重新整理後調整人數。": "請持續關注通知並了解是否有名額釋出，重新整理後調整人數。",
  "請重新登入後再報名。": "請重新登入後再報名。",
  "請重新登入後再試。": "請重新登入後再試。",
  "請重新選擇有效的場地。": "請重新選擇有效的場地。",
  "請稍後再試。": "請稍後再試。",
  "請填寫完整的日期與時間。": "請填寫完整的日期與時間。",
  "請填寫所有必填欄位": "請填寫所有必填欄位",
  "請填寫團名並選擇場地。": "請填寫團名並選擇場地。",
  "請填寫顯示名稱、性別與出生日期。": "請填寫顯示名稱、性別與出生日期。",
  "請補上顯示名稱、性別與出生日期；電話可以留空。": "請補上顯示名稱、性別與出生日期；電話可以留空。",
  "請確認以下訂單資訊": "請確認以下訂單資訊",
  "請確認帳號名稱、每位成員的性別，以及同行者的運動程度。": "請確認帳號名稱、每位成員的性別，以及同行者的運動程度。",
  "請確認網路環境或稍後重試": "請確認網路環境或稍後重試",
  "請閱讀並同意主辦人規範": "請閱讀並同意主辦人規範",
  "請輸入人數": "請輸入人數",
  "請輸入代碼": "請輸入代碼",
  "請輸入名字": "請輸入名字",
  "請輸入名字與電話": "請輸入名字與電話",
  "請輸入有效的手機號碼": "請輸入有效的手機號碼",
  "請輸入事由": "請輸入事由",
  "請輸入真實姓名": "請輸入真實姓名",
  "請輸入單位名稱": "請輸入單位名稱",
  "請輸入需求": "請輸入需求",
  "請選擇": "請選擇",
  "請選擇 PDF 檔案": "請選擇 PDF 檔案",
  "請選擇有效且不晚於今天的出生日期。": "請選擇有效且不晚於今天的出生日期。",
  "請選擇有效的租期。": "請選擇有效的租期。",
  "請選擇有效的程度。": "請選擇有效的程度。",
  "請選擇場地": "請選擇場地",
  "請選擇程度": "請選擇程度",
  "器材租借": "器材租借",
  "操作太頻繁": "操作太頻繁",
  "整年租": "整年租",
  "機車停車場": "機車停車場",
  "歷史預約": "歷史預約",
  "篩選": "篩選",
  "篩選球團": "篩選球團",
  "篩選程度": "篩選程度",
  "輸入電話號碼": "輸入電話號碼",
  "選單": "選單",
  "選單，有未讀通知": "選單，有未讀通知",
  "選擇日期": "選擇日期",
  "選擇日期與時間進行預約": "選擇日期與時間進行預約",
  "選擇出生日期": "選擇出生日期",
  "選擇排序方式": "選擇排序方式",
  "選擇場地與時段": "選擇場地與時段",
  "選擇預約日期": "選擇預約日期",
  "選擇預約週次": "選擇預約週次",
  "錯誤": "錯誤",
  "儲存中...": "儲存中...",
  "儲存成功": "儲存成功",
  "儲存程度": "儲存程度",
  "儲存變更": "儲存變更",
  "總金額：NT$ {value0}": "總金額：NT$ {value0}",
  "聯絡主揪": "聯絡主揪",
  "聯絡資訊（選填，最多 500 字）": "聯絡資訊（選填，最多 500 字）",
  "聯絡電話": "聯絡電話",
  "臨打": "臨打",
  "臨打團": "臨打團",
  "臨打團已建立；列表會依目前的篩選條件顯示。": "臨打團已建立；列表會依目前的篩選條件顯示。",
  "臨打團分頁": "臨打團分頁",
  "臨打團主": "臨打團主",
  "臨打團清單回應格式不正確": "臨打團清單回應格式不正確",
  "還沒有帳號？": "還沒有帳號？",
  "隱藏": "隱藏",
  "點擊查看地圖 →": "點擊查看地圖 →",
  "點擊查看臨打團詳細資訊 →": "點擊查看臨打團詳細資訊 →",
  "簡介（選填，最多 100 字）": "簡介（選填，最多 100 字）",
  "簡介或聯絡資訊超過字數限制。": "簡介或聯絡資訊超過字數限制。",
  "關閉": "關閉",
  "關閉建立表單": "關閉建立表單",
  "關閉活動清單": "關閉活動清單",
  "嚴禁利用平台進行商業營利或黃牛行為。": "嚴禁利用平台進行商業營利或黃牛行為。",
  "籃球": "籃球",
  "籃球架 x2": "籃球架 x2",
  "籃球場": "籃球場",
  "歡迎，": "歡迎，",
  "讀取中...": "讀取中...",
  "顯示": "顯示",
  "顯示名稱": "顯示名稱",
  "顯示詳細": "顯示詳細",
  "體育課程教學優先，不得以任何理由要求讓場。": "體育課程教學優先，不得以任何理由要求讓場。",
  "體育館暨游泳池嚴禁抽煙與進食，違者隨時停止其使用權利。": "體育館暨游泳池嚴禁抽煙與進食，違者隨時停止其使用權利。",
  "體驗 LINE 登入／註冊（展示）": "體驗 LINE 登入／註冊（展示）",
  "觀眾席": "觀眾席",
  "Email、username、頭像與組織資料無法透過目前 API 修改。": "Email、username、頭像與組織資料無法透過目前 API 修改。",
  "Google Maps 導航": "Google Maps 導航",
  "Google Maps script 載入失敗（請看 Console / Network）": "Google Maps script 載入失敗（請看 Console / Network）",
  "LINE 大頭貼": "LINE 大頭貼",
  "LINE 登入／註冊體驗": "LINE 登入／註冊體驗",
  "LINE 登入失敗": "LINE 登入失敗",
  "LINE 登入回應格式不正確": "LINE 登入回應格式不正確",
  "LINE 帳號綁定": "LINE 帳號綁定",
  "解除 LINE 綁定": "解除 LINE 綁定",
  "解除 LINE 綁定？": "解除 LINE 綁定？",
  "解除綁定中...": "解除綁定中...",
  "確認解除綁定": "確認解除綁定",
  "解除綁定成功": "解除綁定成功",
  "LINE 帳號已與目前帳號解除綁定。": "LINE 帳號已與目前帳號解除綁定。",
  "解除後，這個 LINE 帳號將無法再登入目前帳號。請先確認已有其他登入方式。": "解除後，這個 LINE 帳號將無法再登入目前帳號。請先確認已有其他登入方式。",
  "解除後將無法再用這個 LINE 帳號登入目前帳號。": "解除後將無法再用這個 LINE 帳號登入目前帳號。",
  "目前帳號未綁定 LINE。": "目前帳號未綁定 LINE。",
  "LINE 尚未綁定": "LINE 尚未綁定",
  "目前帳號沒有綁定 LINE，無需解除。": "目前帳號沒有綁定 LINE，無需解除。",
  "無法解除 LINE 綁定": "無法解除 LINE 綁定",
  "LINE 是目前唯一的登入方式，請先設定密碼，再解除綁定。": "LINE 是目前唯一的登入方式，請先設定密碼，再解除綁定。",
  "登入信箱與密碼": "登入信箱與密碼",
  "登入信箱": "登入信箱",
  "設定登入信箱與密碼": "設定登入信箱與密碼",
  "儲存登入密碼": "儲存登入密碼",
  "設定密碼": "設定密碼",
  "確認密碼": "確認密碼",
  "先設定登入密碼": "先設定登入密碼",
  "設定密碼並解除 LINE 綁定": "設定密碼並解除 LINE 綁定",
  "LINE 是目前唯一的登入方式。設定信箱與密碼後，才可以解除綁定。": "LINE 是目前唯一的登入方式。設定信箱與密碼後，才可以解除綁定。",
  "此帳號已有信箱，會沿用原本的信箱。": "此帳號已有信箱，會沿用原本的信箱。",
  "請輸入有效的電子信箱。": "請輸入有效的電子信箱。",
  "密碼至少需要 8 個字元。": "密碼至少需要 8 個字元。",
  "兩次輸入的密碼不一致。": "兩次輸入的密碼不一致。",
  "請確認信箱與密碼是否符合要求。": "請確認信箱與密碼是否符合要求。",
  "此帳號已設定密碼，無法再次設定。": "此帳號已設定密碼，無法再次設定。",
  "密碼設定成功": "密碼設定成功",
  "現在可以使用信箱與密碼登入。": "現在可以使用信箱與密碼登入。",
  "密碼已設定，但 LINE 仍無法解除。請重新整理後再試。": "密碼已設定，但 LINE 仍無法解除。請重新整理後再試。",
  "此帳號已設定密碼，可以使用信箱與密碼登入。": "此帳號已設定密碼，可以使用信箱與密碼登入。",
  "尚未設定密碼時，可在此補上登入信箱與密碼。每個帳號只能設定一次。": "尚未設定密碼時，可在此補上登入信箱與密碼。每個帳號只能設定一次。",
  "登入信箱可在首次設定密碼時補上；username、頭像與組織資料無法在此修改。": "登入信箱可在首次設定密碼時補上；username、頭像與組織資料無法在此修改。",
  "正在載入基本資料…": "正在載入基本資料…",
  "請補上必填的基本資料，完成後即可前往臨打團。電話可以留空。": "請補上必填的基本資料，完成後即可前往臨打團。電話可以留空。",
  "請選擇有效的性別與出生日期。": "請選擇有效的性別與出生日期。",
  "完成並前往臨打團": "完成並前往臨打團",
  "LINE 體驗者": "LINE 體驗者",
  "NTUST 場地預約系統": "NTUST 場地預約系統",
  "T4教學大樓旁": "T4教學大樓旁",
};
